
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  TasksListParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\TasksListParameters.ts

export class TasksListParameters {

  // int? IntUserId
  public IntUserId?: number=null;

  // string LngCod
  public LngCod?: string=null;

  // bool? TopMesTaches
  public TopMesTaches?: boolean=null;

  // bool? TopMemeNiveau
  public TopMemeNiveau?: boolean=null;

  // bool? TopAttente
  public TopAttente?: boolean=null;
}